import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "antd";
import usePasskeyBrowserSupport from "../app/routes/security/passKeys/PassKeyUtil";
import Base64 from "../../util/Base64";
import React, { useState } from "react";
import axios from "axios";
import { axiosErrorHandler } from "../../swzutils";
import { dispatchLoginResponseV6Router, performPasskeyLogin } from "./PerformLogin";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAppDispatch } from "../../store";
const PassKeyLoginForm = (props) => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useAppDispatch();
    const { publicKeyCredentialAvailable, conditionalMediationAvailable, userVerifyingPlatformAuthenticatorAvailable } = usePasskeyBrowserSupport();
    if (!publicKeyCredentialAvailable) {
        return null;
    }
    const promptForPassKey = (options) => {
        navigator.credentials.get({
            publicKey: {
                challenge: Base64.fromBase64(options.challenge, 'base64url').data,
                rpId: options.relyingPartyId,
                userVerification: options.userVerification,
            }
        }).then((result) => {
            if (result) {
                setLoading(true);
                performPasskeyLogin(options, result, (loginResponse, errorMsg, mfaRequired) => {
                    props.errorMessageHandler(errorMsg);
                    setLoading(false);
                    // if (mfaRequired) { // Only set the positive case, we set OTP required to false if the username field is modified
                    //     setRequiresOTP(mfaRequired);
                    // }
                    if (loginResponse && !mfaRequired && !errorMsg) {
                        dispatchLoginResponseV6Router(loginResponse, navigate, searchParams.get("toUrl"), dispatch);
                    }
                });
            }
        }).catch((e) => {
            console.log("Passkey login aborted", e);
        });
    };
    const initPasskeyLogin = () => {
        setLoading(true);
        axios.post('/admin/v1/authentication/passkey/setup')
            .then(response => {
            return response.data;
        })
            .catch(axiosErrorHandler)
            .finally(() => {
            setLoading(false);
        })
            .then((options) => {
            if (options) {
                promptForPassKey(options);
            }
        });
    };
    return (_jsx(Button, { onClick: initPasskeyLogin, loading: loading, disabled: loading, children: "Login with passkey" }));
};
export default PassKeyLoginForm;
